import { axiosInstance } from "../axios-instance";

const socialMedia = "social_media";

const PropertiesServices = {
  getSocailMedia: () => axiosInstance.get(`${socialMedia}`),
  updateSocailMedia: (payload) =>
    axiosInstance.post(`${socialMedia}/update/${payload.id}`, payload),
  storeSocailMedia: (payload) =>
    axiosInstance.post(`${socialMedia}/store`, payload),
  deleteSocailMedia: (id) =>
    axiosInstance.delete(`${socialMedia}/delete/${id}`),
};

export default PropertiesServices;
